module.exports = __webpack_public_path__ + "media/images/area/feature/banner/pc/ja_hokkaido-8b77b51437996a67892ee4b91100e65e.jpg";